export const categories = [
  {
    slug: 'wanghong-tafang',
    name: '网红塌房',
    description: '实时追踪网红翻车现场，第一时间爆料塌房内幕，让粉丝看清真相',
    icon: 'ri-alert-line',
    color: 'accent',
  },
  {
    slug: 'heiliao-baoliao',
    name: '黑料爆料',
    description: '深度挖掘娱乐圈最新黑料，独家曝光不为人知的秘密与内幕',
    icon: 'ri-spy-line',
    color: 'primary',
  },
  {
    slug: 'meiri-dasai',
    name: '每日大赛',
    description: '每日追踪热门话题大赛，吃瓜群众最关注的实时热点事件汇总',
    icon: 'ri-fire-line',
    color: 'accent',
  },
  {
    slug: 'yule-bagua',
    name: '娱乐八卦',
    description: '明星八卦、影视圈内幕、综艺趣事，娱乐圈大小事一网打尽',
    icon: 'ri-chat-smile-2-line',
    color: 'secondary',
  },
  {
    slug: 'zhibo-chigua',
    name: '直播吃瓜',
    description: '热门直播间实时录屏吃瓜，主播翻车名场面全记录',
    icon: 'ri-live-line',
    color: 'primary',
  },
  {
    slug: 'shipin-remen',
    name: '视频热门',
    description: '热门吃瓜视频合集，51吃瓜在线观看最新最热的吃瓜视频内容',
    icon: 'ri-video-line',
    color: 'secondary',
  },
];

export const categoryColorMap: Record<string, { bg: string; text: string; badge: string; badgeText: string }> = {
  accent: { bg: 'bg-accent-500', text: 'text-accent-500', badge: 'bg-accent-100', badgeText: 'text-accent-800' },
  primary: { bg: 'bg-primary-500', text: 'text-primary-500', badge: 'bg-primary-100', badgeText: 'text-primary-800' },
  secondary: { bg: 'bg-secondary-500', text: 'text-secondary-500', badge: 'bg-secondary-100', badgeText: 'text-secondary-800' },
};